import React, { useState } from "react";
import moment from "moment";
import { tockSearchUrl } from "../utils/tock";
import TockLogo from "../images/tock-logo.png";

const GUEST_OPTIONS = Array.from({ length: 12 }, (_, i) => i + 1);

/**
 * Custom reservation search that mirrors Tock's date / guests / Find a Table
 * widget, then sends guests to Tock with those params.
 */
export default function ReservationFinder({
  className = "",
  buttonLabel = "Find a Table",
  defaultGuests = 2,
}) {
  const [date, setDate] = useState(() => moment().format("YYYY-MM-DD"));
  const [guests, setGuests] = useState(defaultGuests);

  const href = tockSearchUrl(guests, date);
  const minDate = moment().format("YYYY-MM-DD");

  return (
    <form
      className={`tock-finder ${className}`.trim()}
      onSubmit={(event) => {
        event.preventDefault();
        window.open(href, "_blank", "noopener,noreferrer");
      }}
    >
      <div className="tock-finder__fields">
        <label className="tock-finder__field">
          <span className="tock-finder__label">Date</span>
          <input
            className="tock-finder__input"
            type="date"
            name="date"
            min={minDate}
            value={date}
            onChange={(event) => setDate(event.target.value)}
            required
          />
        </label>
        <label className="tock-finder__field">
          <span className="tock-finder__label">Guests</span>
          <select
            className="tock-finder__input tock-finder__select"
            name="guests"
            value={guests}
            onChange={(event) => setGuests(Number(event.target.value))}
          >
            {GUEST_OPTIONS.map((count) => (
              <option key={count} value={count}>
                {count} {count === 1 ? "guest" : "guests"}
              </option>
            ))}
          </select>
        </label>
        <button className="tock-finder__submit" type="submit">
          <span>{buttonLabel}</span>
          <span className="tock-finder__external-icon" aria-hidden="true" />
        </button>
      </div>
      <p className="tock-finder__powered">
        <span className="tock-finder__powered-label">Powered by</span>
        <img
          className="tock-finder__logo"
          src={TockLogo}
          alt="Tock"
          height={18}
        />
      </p>
    </form>
  );
}
